/**
 * Created by ShaunBetts on 23-Apr-16.
 */

const SET = 'set';

// initial state
const state = {
  environment: {
    route: DEFAULT_ENVIRONMENT
  }
};

//actions
const actions = {
  mergeInNew({commit, state}, {environmentFromRemote}) {
    let environment = _.cloneDeep(state.environment);

    _.forEach(environment, (environmentValue, environmentKey) => {
      if (environmentFromRemote[environmentKey]) {
        environment[environmentKey] = environmentFromRemote[environmentKey];
      }
    });

    commit(SET, environment);
  },
  setRoute({commit, state}, route){
    let environment = _.cloneDeep(state.environment);
    environment.route = route;
    commit(SET, environment);
  }
};

//getters prawns
const getters = {
  route(state){
    return _.get(state, 'environment.route', null);
  }
};

// mutations
const mutations = {
  set(state, environment) {
    state.environment = environment;
  }
};

export default {
  state,
  actions,
  getters,
  mutations
}
